import { HttpErrorResponse } from "@angular/common/http";
import { Result } from "neverthrow";
import { HttpResult } from "src/app/infra/http/type";
import { DataSourceReturn } from "src/app/services/Repositorys/type";

export abstract class IAttachmentRemoteRepository  {
  abstract getAttachment(id: string | number): Promise<Result<HttpResult<Blob>, HttpErrorResponse>>
}
